// Module
var code = "<svg class=\"iconDivider noSelect\" width=\"14\" height=\"14\"><g fill-rule=\"evenodd\"><circle cx=\"7\" cy=\"12\" r=\"2\"/><circle cx=\"7\" cy=\"2\" r=\"2\"/><rect width=\"14\" height=\"2\" y=\"6\" rx=\"1\"/></g></svg>";
// Exports
module.exports = code;